import { createAsyncThunk } from '@reduxjs/toolkit'

import { dashboardApi } from './dashboard-api'

export const fetchCategories = createAsyncThunk('dashboard/fetchCategories', async _ => {
  try {
    return await dashboardApi.getCategories()
  } catch (e) {
    console.warn(e)
  }
})

export const setResult = createAsyncThunk(
  'dashboard/setResult',
  async (param: { categoryId: string; taskId: string; result: number }) => {
    try {
      return await dashboardApi.setResult(param)
    } catch (e) {
      console.warn(e)
    }
  }
)

export const resetActivity = createAsyncThunk('dashboard/resetActivity', async () => {
  try {
    await dashboardApi.resetResult()
    localStorage.removeItem('activity')
  } catch (e) {
    console.warn(e)
  }
})
